import { Button } from "@blueprintjs/core"
import { VKVideoItem } from "src/libs/interfaces/layouts"
import { __, wordTrim } from "src/libs/utilities"
import Shortcode from "../shortcode"

/* Protopia Ecosystem component */
export interface IPlayListItemProps {
    item: VKVideoItem
    defImage?: URL | string
    i:number
    isCurrent:boolean
    onClick: () => void
}
const PlayListItem = (props: IPlayListItemProps): JSX.Element => {
    return <Button fill variant={props.isCurrent ? "solid" : "minimal"} className="btn-stretch p-1" onClick={props.onClick}>
        <div className="text-wrap">
            <div 
                className="thumbnail bg-contrast-opacity mr-3 mb-3" 
                style={{ 
                    backgroundImage:`url(${props.item.image || props.defImage})`, 
                    float: "left" 
                }}
            />
            <div className="">
                <Shortcode content={wordTrim(props.item.label || __("Unknown video"), 10) } className="title mb-1 video-title" title={ props.item.label || __("Unknown video") }/>
                <Shortcode content={ wordTrim(props.item.content || "", 35) } className="small video-description" title={ props.item.content || "" }  />
            </div>
        </div>
        
    </Button>
}
export default PlayListItem